export function checkAoi(aoi) {
  if (!aoi) return false;
  return Boolean(aoi.points);
}
